module.exports = __webpack_public_path__ + "img/epr-price_medium@2x.e7ab5461.webp";